export default __webpack_public_path__ + "static/all-buttons-light-2c35c62855b6a1e9e0821c73489f8b2992808747ffd91cba89bcdefef45f8dd8.png";